import { useQuery } from "@apollo/client";
import { SELLING_LIMITATIONS } from "../pharmacyTypeDefs";

export const useQuerySellingLimitations = (options?: any): any => (
  useQuery(SELLING_LIMITATIONS, options)
);
